import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import {LayoutVo} from '../../common/shared/api/karina/vo/LayoutVo.interface';

/**
 * Layout 조회
 *
 * Origin: pageKarinaApi.getLayout
 * API: GET /v1/layout
 */
export async function getLayout(
  screenUid?: number,
  options?: FetcherOptions
): Promise<ApiResultVo<LayoutVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/view/v1/layout',
    {
      method: 'GET',
      params: {
        screen_uid: screenUid,
      },
    },
    options
  );
  return response.data;
}
